// 审批管理
export default {
    autoApprovalSettings: 'Настройки автоматического одобрения',
    taskNumber: 'номер задачи',
    approvalTime: 'Время обработки',
    approver: 'Утверждающий',
    reasonFailure: 'Причина отказа',
    mapView: 'вид карты',
    pass: 'пройти через',
    fail: 'Потерпеть неудачу',
    tip_pleaseEnterFail: 'Пожалуйста, введите причину сбоя',
    tip_surePass: 'Вы уверены, что пройдете?',
    warning1: 'Функция автоматического утверждения должна вступить в силу после настройки.',
    warning2: 'После включения автоматического утверждения одобрение, представленное пользователями в списке автоматического утверждения, будет автоматически пропущено, но система все равно запишет задачу.',
    department: 'отделение',
    username: 'имя пользователя',
    phoneNumber: 'Телефонный номер',
    userManagement: 'Управление пользователями',
    role: 'Роль',
    remove: 'Удалить',
    bulkRemoval: 'Массовое удаление',
    tip_remove: 'Ты уверен что хочешь удалить?',
    autoApproval: 'автоматическое одобрение',
    userNotAdded: 'Пользователь не добавлен',
    userAdded: 'Пользователь добавлен',
    pleaseEnterUserName: 'пожалуйста, введите имя пользователя',
    viewTasks: 'Просмотр задач',
    autoApprovalPeriod: 'Период автоматического одобрения',
    approvalTaskType: 'Тип задачи утверждения',
    enterAutoApproval: 'Пожалуйста, введите период автоматического одобрения',
}